import instance from "../../utils/axios";

const toFormData = (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) =>
    formData.append(key, val ?? "")
  );
  return formData;
};

// SAVE
export const saveServiceVideo = async (payload) => {
  return (
    await instance.post(
      "/churches/services/servicevideos/save",
      toFormData(payload)
    )
  ).data;
};

// UPDATE
export const updateServiceVideo = async (payload) => {
  return (
    await instance.post(
      "/churches/services/servicevideos/update",
      toFormData(payload)
    )
  ).data;
};

// DELETE
export const deleteServiceVideo = async (payload) => {
  return (
    await instance.post(
      "/churches/services/servicevideos/delete",
      toFormData(payload)
    )
  ).data;
};

// READ
export const readServiceVideos = async (payload) => {
  return (
    await instance.post(
      "/churches/services/servicevideos/read",
      toFormData(payload)
    )
  ).data;
};
